import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import Container from '@/components/Container';
import BlockWrapper from '@/components/BlockWrapper';
import MediumCard, { MediumCardData } from '@/components/MediumCard';
import Title from '@/components/Title';
import { isDarkTheme } from '@/utils/StyleUtils';
import { mediaQuery } from '@/utils/helpers';

const CardsWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2.4rem;
  padding: 0;
  list-style: none;

  ${mediaQuery.md(`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  `)}
`;

const BlockContent = styled.div`
  text-align: center;
  margin: 0 0 3.2rem;

  ${mediaQuery.md(`
    margin: 0 0 7rem;
`)}
`;

type Props = {
  id: string;
  title: string;
  backgroundColor: string;
  cards: Array<MediumCardData>;
};
const MediumCardBlock: React.FC<Props> = ({
  id,
  backgroundColor,
  title,
  cards,
}) => {
  const dark = isDarkTheme(backgroundColor);
  return (
    <BlockWrapper id={id} color={backgroundColor}>
      <Container>
        <BlockContent>
          <Title size='xl' level='h2' margin='0 0 2.4rem' lightColor={dark}>
            {title}
          </Title>
        </BlockContent>
        <CardsWrapper>
          {React.Children.toArray(
            cards.map((card) => {
              return MediumCard({ ...card });
            }),
          )}
        </CardsWrapper>
      </Container>
    </BlockWrapper>
  );
};

export default MediumCardBlock;
export const largeCardsBlockFragmentQuery = graphql`
  fragment MediumCardsBlockFragment on ContentfulMediumCardsBlock {
    id
    __typename
    title
    backgroundColor
    cards: mediumCards {
      ...MediumCardFragment
    }
  }
`;
